import { useCallback, useEffect, useRef } from "react";

// 마우스가 잠깐(기본 0.18초) 머물렀을 때만 실행한다. 탭·카드 위를 지나가기만 할 때 내용이 연달아 바뀌며 깜빡이는 것을 막는다.
export const HOVER_INTENT_MS = 180;

export function useHoverIntent(delay = HOVER_INTENT_MS) {
  const timer = useRef(0);
  useEffect(() => () => clearTimeout(timer.current), []);
  const enter = useCallback(
    (fn) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(fn, delay);
    },
    [delay]
  );
  const leave = useCallback(() => clearTimeout(timer.current), []);
  return { enter, leave };
}
